(function($) {

	$.fn.userNavigation = function() {
		
		return this.each(function() {
			var $userNavigationLink = $(this);

            var $userNavigationContent = $userNavigationLink.next();

            $userNavigationLink.on('click', function(e){
                if ($userNavigationContent.is(':hidden')) {
                    $userNavigationContent.fadeIn('fast');
                    return false;
                }
                e.preventDefault();
                return true;
            });
            $("html").click(function(eventObject){
                if($(eventObject.target).parents().andSelf().filter($userNavigationContent).size()==0)
                {
                    $userNavigationContent.fadeOut('fast');
                }
            });
        });
	};

})(jQuery);